// Lib
import React from 'react'
import { Route, Routes } from 'react-router-dom'

// Images

// Include in project
import {
  Demo,
  Login,
  ForgotPassword,
  ListOfSpecialCampaigns,
  ListOfNormalCampaigns,
  CallFromDMS,
  CampaignCalendar,
  UserRoleManagement,
  UserListManagement,
  CreateNormalCampaign,
  CreateSpecialCampaign,
  BrandManagement,
  TagsManagement,
  UnitManagement,
  ProductManagement,
  ProvinceManagement,
  ShopManagement,
  ReviewCampaignList,
  ReviewCampaignDetail,
  SendPointToUrbox,
  CheckPointCampaignList,
  CheckPointCampaignDetail,
  ApprovePointCampaignList,
  ApprovePointCampaignDetail,
  SegmentManagement,
  ZoneManagement,
  DistrictManagement,
  ShopBigRetailerManagement,
  Dashboard,
} from 'pages'
import { ModalDialogWithRedux, NotificationWithRedux, ProtectedRoute, ProtectedRoutePermission } from 'component'
import 'i18n/i18n'
import { EPermissionToken } from 'utils/other'

const App: React.FC = () => {
  console.log('ENV', process.env.REACT_APP_STATE)

  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        <Route path="" element={<ProtectedRoute />}>
          <Route path="/demo" element={<Demo />} />

          <Route path="/" element={<Dashboard />} />

          <Route path="" element={<ProtectedRoutePermission permission={[EPermissionToken.CallFromDms]} />}>
            <Route path="/call-from-dms" element={<CallFromDMS />} />
          </Route>

          <Route path="" element={<ProtectedRoutePermission permission={[EPermissionToken.Calendar]} />}>
            <Route path="/campaign/calendar" element={<CampaignCalendar />} />
          </Route>

          <Route path="" element={<ProtectedRoutePermission permission={[EPermissionToken.NormalCampaign]} />}>
            <Route path="/campaign/list-normal" element={<ListOfNormalCampaigns />} />
            <Route path="/campaign/list-normal/create" element={<CreateNormalCampaign />} />
          </Route>

          <Route path="" element={<ProtectedRoutePermission permission={[EPermissionToken.SpecialCampaign]} />}>
            <Route path="/campaign/list-special" element={<ListOfSpecialCampaigns />} />
            <Route path="/campaign/list-special/create" element={<CreateSpecialCampaign />} />
          </Route>

          <Route path="" element={<ProtectedRoutePermission permission={[EPermissionToken.ApproveCampaign]} />}>
            <Route path="/review-and-approval/review-campaign-list" element={<ReviewCampaignList />} />
            <Route path="/review-and-approval/review-campaign-list/detail" element={<ReviewCampaignDetail />} />
          </Route>

          <Route path="" element={<ProtectedRoutePermission permission={[EPermissionToken.ReviewPoint]} />}>
            <Route path="/check-point/campaign-list" element={<CheckPointCampaignList />} />
            <Route path="/check-point/campaign-list/detail" element={<CheckPointCampaignDetail />} />
          </Route>

          <Route path="" element={<ProtectedRoutePermission permission={[EPermissionToken.ApprovePoint]} />}>
            <Route path="/approve-point/campaign-list" element={<ApprovePointCampaignList />} />
            <Route path="/approve-point/campaign-list/detail" element={<ApprovePointCampaignDetail />} />
          </Route>

          <Route path="" element={<ProtectedRoutePermission permission={[EPermissionToken.SendPoint]} />}>
            <Route path="/send-point" element={<SendPointToUrbox />} />
          </Route>

          {/* Master Data */}
          <Route path="" element={<ProtectedRoutePermission permission={[EPermissionToken.Zone]} />}>
            <Route path="/master-data/zone" element={<ZoneManagement />} />
          </Route>

          <Route path="" element={<ProtectedRoutePermission permission={[EPermissionToken.Province]} />}>
            <Route path="/master-data/province" element={<ProvinceManagement />} />
          </Route>

          <Route path="" element={<ProtectedRoutePermission permission={[EPermissionToken.District]} />}>
            <Route path="/master-data/district" element={<DistrictManagement />} />
          </Route>

          <Route path="" element={<ProtectedRoutePermission permission={[EPermissionToken.Segment]} />}>
            <Route path="/master-data/segment" element={<SegmentManagement />} />
          </Route>

          <Route path="" element={<ProtectedRoutePermission permission={[EPermissionToken.Brand]} />}>
            <Route path="/master-data/brand" element={<BrandManagement />} />
          </Route>

          <Route path="" element={<ProtectedRoutePermission permission={[EPermissionToken.Product]} />}>
            <Route path="/master-data/product" element={<ProductManagement />} />
          </Route>

          <Route path="" element={<ProtectedRoutePermission permission={[EPermissionToken.Unit]} />}>
            <Route path="/master-data/unit" element={<UnitManagement />} />
          </Route>

          <Route path="" element={<ProtectedRoutePermission permission={[EPermissionToken.ShopRetailer]} />}>
            <Route path="/master-data/shop" element={<ShopManagement />} />
          </Route>

          <Route path="" element={<ProtectedRoutePermission permission={[EPermissionToken.ShopBigRetailer]} />}>
            <Route path="/master-data/big-retailer" element={<ShopBigRetailerManagement />} />
          </Route>

          <Route path="" element={<ProtectedRoutePermission permission={[EPermissionToken.Tag]} />}>
            <Route path="/master-data/tags" element={<TagsManagement />} />
          </Route>

          {/* User Management */}
          <Route path="" element={<ProtectedRoutePermission permission={[EPermissionToken.UserRole]} />}>
            <Route path="/user-management/role" element={<UserRoleManagement />} />
          </Route>

          <Route path="" element={<ProtectedRoutePermission permission={[EPermissionToken.UserList]} />}>
            <Route path="/user-management/user" element={<UserListManagement />} />
          </Route>
        </Route>
      </Routes>
      <ModalDialogWithRedux />
      <NotificationWithRedux />
    </>
  )
}

export default App
